<template>
  <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm" :size="formSize"
    status-icon>
    <el-form-item label="职业" prop="userType">
      <el-select filterable multiple v-model="ruleForm.userType" placeholder="">
        <el-option v-for="item in allType" :key="item.id" :label="item.roleName" :value="item.id" />
      </el-select>
    </el-form-item>
    <el-form-item label="姓名" prop="name">
      <el-input v-model="ruleForm.name" />
    </el-form-item>
    <el-form-item label="性别" prop="sex">
      <el-radio-group v-model="ruleForm.sex">
        <el-radio :label="1">男</el-radio>
        <el-radio :label="2">女</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="账号" prop="userName">
      <el-input v-model="ruleForm.userName" />
    </el-form-item>
    <el-form-item label="到期日期" prop="expireTime">
      <el-date-picker v-model="ruleForm.expireTime" autocomplete="new-password" type="date" format="YYYY-MM-DD"
        value-format="YYYY-MM-DD" />
    </el-form-item>
    <el-form-item label="登录密码" prop="password">
      <el-input type="password" autocomplete="new-password" v-model="ruleForm.password" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="default" @click="submitForm(ruleFormRef)">
        保存
      </el-button>
      <el-button size="default" @click="closeForm">关闭</el-button>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { reactive, ref, defineEmits, defineExpose, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { userSaveOrUpdate, roleAll } from "@/http/http";
const formSize = ref("default");
const emit = defineEmits(["dialogClose"]);
const ruleFormRef = ref();
let allType = ref("");
const ruleForm = reactive({
  userType: 1,
  name: "",
  type: "",
  sex: 1,
  userName: "",
  password: "",
  expireTime:null
});

const rules = reactive({});

const init = (row) => {
  for (const key in row) {
    ruleForm[key] = row[key];
  }
};
defineExpose({ init });


const _roleAll = () => {
  roleAll().then((res) => {
    if (res.data.code == 200) {
      console.log(res.data);
      allType.value = res.data.data
    }
  });
};

onMounted(() => {
  _roleAll();
});
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      ruleForm.password == "" && delete ruleForm.password;
      userSaveOrUpdate(ruleForm).then((res) => {
        if (res.data.code == 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          emit("dialogClose", true);
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

const closeForm = () => {
  emit("dialogClose");
};
</script>
